// Carousel
import React, { Fragment, ReactNode } from 'react';
import styles from './Carousel.module.sass';
import cn from 'classnames';

export interface CarouselProps {
  slides: ReactNode[];
  className?: string;
}

const Carousel: React.FC<CarouselProps> = ({ slides, className }) => {
  return (
    <div className={cn(styles.carousel, className)}>
      {slides.map((s, i) => (
        <Fragment key={i}>{s}</Fragment>
      ))}
    </div>
  );
};

export default Carousel;
